export default function loadLeadfeeder() {
  (function(ss, ex) {
    window.ldfdr = window.ldfdr || function() {
      (window.ldfdr._q = window.ldfdr._q || []).push(arguments);
    };

    (function(d, s) {
      const fs = d.getElementsByTagName(s)[0];
      function ce(src) {
        const cs = d.createElement(s);
        cs.src = src;
        cs.async = true;
        fs.parentNode.insertBefore(cs, fs);
      }

      const scriptSrc = `https://sc.lfeeder.com/lftracker_v1_${ss}${ex ? `_${ex}` : ''}.js`;
      ce(scriptSrc);
    })(document, 'script');
  })('Xbp1oaE9DznaEdVj');
}
